/* global axios */
// Integração Wavoip (ligações WhatsApp via webphone). Carrega o SDK UMD do CDN
// uma única vez, registra os tokens da conta e inicia chamadas. Porta do widget
// do AstraChat original (window.wavoip / @wavoip/wavoip-webphone).
const SDK_URL =
  'https://cdn.jsdelivr.net/npm/@wavoip/wavoip-webphone@latest/dist/index.umd.min.js';

let ready = false;
let initInFlight = null;

const loadScript = () =>
  new Promise((resolve, reject) => {
    if (window.wavoipWebphone) {
      resolve();
      return;
    }
    const s = document.createElement('script');
    s.src = SDK_URL;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });

const fetchTokens = async accountId => {
  const { data } = await axios.get(
    `/api/v1/accounts/${accountId}/kanban/wavoip_tokens/all`
  );
  return data.data || [];
};

const initWavoip = async accountId => {
  if (ready) return true;
  if (initInFlight) return initInFlight;
  initInFlight = (async () => {
    const tokens = await fetchTokens(accountId);
    if (!tokens.length) return false;
    await loadScript();
    const api = await window.wavoipWebphone.render({
      theme: 'system',
      position: 'bottom-right',
      widget: { startOpen: false, showWidgetButton: false },
      callSettings: { displayName: 'Atendimento' },
    });
    tokens.forEach(t => api.device.add(t, true));
    api.on('call:accepted', () => {
      try {
        api.widget.open();
      } catch (e) {
        /* noop */
      }
    });
    api.on('call:ended', () => {
      try {
        api.widget.close();
      } catch (e) {
        /* noop */
      }
    });
    ready = true;
    return true;
  })();
  try {
    return await initInFlight;
  } finally {
    initInFlight = null;
  }
};

export function useWavoip() {
  const startCall = async (accountId, phone) => {
    const ok = await initWavoip(accountId);
    if (!ok || !window.wavoip) {
      throw new Error('wavoip-not-ready');
    }
    const digits = String(phone || '').replace(/\D/g, '');
    if (!digits) throw new Error('no-phone');
    const devices = window.wavoip.device.get() || [];
    const usable = devices
      .filter(d => d.status === 'open' && d.enable !== false)
      .map(d => d.token);
    try {
      window.wavoip.widget.open();
    } catch (e) {
      /* noop */
    }
    const opts = { displayName: 'Atendimento' };
    if (usable.length) opts.fromTokens = usable;
    return window.wavoip.call.start(digits, opts);
  };

  return { startCall };
}
